import { INotification } from "./INotification";
import { IPerformedAction } from "./IPerformedAction";
import { IAction } from "./IAction";
import { Meta } from "./Meta";

export class Notification implements INotification {
	id?: string;

	issuedAt: string;

	receivedAt?: string;

	type?: string;

	source?: string;

	title: string;

	details?: string;

	headerText?: string;

	headerLogo?: string;

	contentLogo?: string;

	timeout?: number;

	cssClassName?: string;

	notificationAlertSound?: string;

	isRead: boolean;

	isMuted: boolean;

	isSnoozed: boolean;

	isDeleted: boolean;

	actions?: Array<IAction | IAction[]>;

	meta?: Meta;

	actionsHistory?: IPerformedAction[];

	stateHistory: INotification[];

	devModeOnly?: boolean;

	constructor() {
		this.actions = [];
		this.isRead = false;
		this.isSnoozed = false;
		this.isMuted = false;
		this.isDeleted = false;
		this.actionsHistory = [];
		this.meta = new Meta();
		this.stateHistory = [];
		this.issuedAt = "";
		this.title = "";
		this.devModeOnly = false;
	}
}
